import { render, staticRenderFns } from "./CompNotifications.vue?vue&type=template&id=75666c76&scoped=true"
import script from "./CompNotifications.vue?vue&type=script&lang=js"
export * from "./CompNotifications.vue?vue&type=script&lang=js"
import style0 from "./CompNotifications.vue?vue&type=style&index=0&id=75666c76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75666c76",
  null
  
)

export default component.exports